import React from 'react';
import FanZoneIntro from '../components/FanZone/FanZoneIntro';

const FanZonePage = () => {
  return <FanZoneIntro />;
};

export default FanZonePage;
